import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnboardingComponent } from './containers/onboarding/onboarding.component';

const routes: Routes = [
  {
    component: OnboardingComponent,
    path: 'onboarding',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class OnboardingRoutingModule {}
